<div class="card" style="margin-bottom: 0px; margin-top: 0px;font-family: Avenir,Avenir Next,Segoe UI,Helvetica,Arial,sans-serif;">
    <div class="card-header card-header-primary">
        <div class="row">
            <div class="col-sm-12 col-md-11">
                <h4 class="card-title"><b> {{data.tituloComentario}} </b></h4>
            </div>
            <div class="col-sm-12 col-md-1">
                <button mat-icon-button (click)="onCloseClick()">
                    <mat-icon>clear</mat-icon>
                </button>
            </div>
        </div>   
    </div>
    <div class="card-body">
        <div class="wraper">
            <div class="container">
                <form [formGroup]="formRegistro">
                    <div class="row">

                        <div class="col-sm-6 border-right">
                            <div>
                                <mat-form-field>
                                    <textarea aria-label="comentario" formControlName="comentario" maxlength="2000" class="border" matInput placeholder="comentario" rows="10" cols="50" style="background: #cecece45">
                                </textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="card">
                                <div class="card-header card-header-tabs card-header-warning">                      
                                  <div class="nav-tabs-navigation">
                                    <div class="nav-tabs-wrapper">
                                      <span class="nav-tabs-title">Lista evidencias: </span>
                                       <ul class="nav nav-tabs" data-tabs="tabs"> 
                                        <li class="nav-item" style="cursor: pointer;">
                                          <button class=" btn-file nav-link" [disabled]="btnAgrega" style="cursor: pointer;">
                                            <a style="cursor: pointer;"><i class="material-icons">add_circle_outline </i> Agregar </a>
                                            <input aria-label="Agregar" type="file" id="nameFile"
                                              accept="image/*, application/*,file_extension|audio/*|video/mp4,video/*|image/*|media_type" mozdirectory
                                              directory multiple (change)='subirEv()' />
                                          </button>
                                          <div class="ripple-container"></div>
                                        </li>
                                        <li class="nav-item" style="cursor: pointer;" [hidden]="btnElimina" >
                                          <button class="nav-link" (click)="elimina()">
                                          <a> <i class="material-icons">highlight_off</i> Remover</a>
                                          </button>                            
                                          <div class="ripple-container"></div>
                                        </li>  
                                      </ul>
                                    </div>
                                  </div>                      
                                </div>
                                <div class="card-body" >
                                  <mat-selection-list style="max-height: 230px; overflow: auto;" [(ngModel)]="selectedOptions"
                                    (ngModelChange)="onNgModelChange($event)" [ngModelOptions]="{standalone: true}">                    
                                    <mat-list-option *ngFor="let item of evidencia; index as i" [value]="item" class="text-muted">
                                      <p class= "text-muted" >{{item.name}} </p>
                                    </mat-list-option>                  
                                  </mat-selection-list>
                                </div>
                              </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6 col-lg-6">
                            <button mat-raised-button class="btn btn-info btn-sm" style="margin-left: 70%" type="submit"
                                (click)='onSave()'>
                                <span><i class="material-icons">save</i></span>
                                &nbsp; Guardar
                            </button>
                        </div>
                        <div class="col-sm-5 col-lg-5" style="align-content: center">
                            <button mat-raised-button class="btn btn-info btn-sm" type="submit" (click)='onNoClick()'>
                                <span><i class="material-icons">cancel</i></span>
                                &nbsp; Cancelar
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>